import type { AppTabPath } from "../application/appTabs";

/** Must match server `DOSSIER_TAB_KEYS` in `consolePermissionMap.js`. */
export const DOSSIER_TAB_PERMISSION_KEYS = [
  "dossier_tab_overview",
  "dossier_tab_beneficiary",
  "dossier_tab_validation",
  "dossier_tab_banking",
  "dossier_tab_subcontractor",
  "dossier_tab_engineer",
  "dossier_tab_work_progress",
  "dossier_tab_po_register",
  "dossier_tab_milestones",
  "dossier_tab_bills",
] as const;

export type DossierTabPermissionKey = (typeof DOSSIER_TAB_PERMISSION_KEYS)[number];

/** Permissions that allow the applicant list and dossier routes (OR semantics). */
export const APPLICATIONS_HUB_ROUTE_PERMISSIONS: string[] = ["applications", ...DOSSIER_TAB_PERMISSION_KEYS];

export const APP_TAB_PATH_TO_DOSSIER_PERMISSION: Record<AppTabPath, DossierTabPermissionKey> = {
  overview: "dossier_tab_overview",
  beneficiary: "dossier_tab_beneficiary",
  validation: "dossier_tab_validation",
  banking: "dossier_tab_banking",
  subcontractor: "dossier_tab_subcontractor",
  engineer: "dossier_tab_engineer",
  "work-progress": "dossier_tab_work_progress",
  "po-register": "dossier_tab_po_register",
  milestones: "dossier_tab_milestones",
  bills: "dossier_tab_bills",
};

export function canAccessApplicationsHub(can: (p: string) => boolean): boolean {
  return can("applications") || DOSSIER_TAB_PERMISSION_KEYS.some((k) => can(k));
}

/** Matches server `applications_no_edit` — view-only dossier access (no saves). */
export const APPLICATIONS_VIEW_ONLY_PERMISSION_KEY = "applications_no_edit";

export function canMutateApplicantDossiers(can: (p: string) => boolean): boolean {
  return canAccessApplicationsHub(can) && !can(APPLICATIONS_VIEW_ONLY_PERMISSION_KEY);
}

export function canSeeDossierMilestonesTab(can: (p: string) => boolean): boolean {
  return can("milestone_templates") && (can("applications") || can("dossier_tab_milestones"));
}
